exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paypalHeader .languageToggleDisplay{position:relative;bottom:0;clear:left;right:0;top:20px;margin-bottom:20px}.paypalHeader #langDropdownBlock{right:auto}.paypalHeader .messengerLogo{margin-left:25%;padding-top:20px}.paypalHeader .venmoLogo{position:absolute;width:100px;height:20px;margin-top:30px;margin-left:10px;background-image:url(https://www.paypalobjects.com/images/checkout/venmo/venmo-logo-blue.png);background-repeat:no-repeat;background-size:100px 20px}@media (max-width:41.3125em){.paypalHeaderWrapper.langDropdown{margin-bottom:30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./components/xo-page-components/src/header/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./components/xo-page-components/src/header/styles.less
// module chunks = 1